import {PopupManager} from '@mintdata/mint-kit/impl/components/popover/PopupManager';
import {PopupItemWithIndex} from '@mintdata/mint-kit/impl/components/popover/PopupState';
import {PopupId} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';

export abstract class PopupHelpers
{
    // todo: use DomUtils.eachParentElement instead
    public static findPopupFromElement(elem:HTMLElement):PopupItemWithIndex | null
    {
        if( !elem )
            return null;

        if( 'hasAttribute' in elem && elem.hasAttribute('data-popupid') )
        {
            const popupManager = PopupManager.getInstance();
            let popupId = elem.getAttribute('data-popupid') as PopupId;
            return popupManager.findPopupItem(popupId);
        }
        else
        {
            return PopupHelpers.findPopupFromElement(elem.parentElement);
        }
    }
}
